import Cookies from 'js-cookie'
import { stringify } from 'query-string'
import simpleRestProvider from 'ra-data-simple-rest'
import { DataProvider, GetListParams, fetchUtils } from 'react-admin'
import { SortDirection } from './GeneratedClients/FreeBillApi'
import firstLettersToUpperCase from './helpers/firstLettersToUpperCase'

const baseUrl = process.env.REACT_APP_DATA_PROVIDER_URL ? process.env.REACT_APP_DATA_PROVIDER_URL : 'http://localhost:5164'
const apiUrl = `${baseUrl}/api/v1`

const httpClient = (url: string, options: fetchUtils.Options = {}) => {
  const customHeaders = (options.headers ||
      new Headers({
          Accept: 'application/json'
      })) as Headers
  const authToken = Cookies.get('Authorization')
  authToken && customHeaders.set('Authorization', authToken)
  options.headers = customHeaders
  return fetchUtils.fetchJson(url, options)
}

const simpleRest = simpleRestProvider(apiUrl, httpClient)

const mapSortDirection = (sortDirection: "ASC" | "DESC") => {
  switch (sortDirection) {
    case "ASC":
      return SortDirection.Ascending
    case "DESC":
      return SortDirection.Descending
    default:
      return SortDirection.Descending;
  }
}

const mapSortAttribute = (sortAttribute: string) => {
  return firstLettersToUpperCase(sortAttribute)
}

const dataProvider: DataProvider = {
  ...simpleRest,
  getList: async(resource: string, params: GetListParams) => {
    const queryObject = {
        pageNumber: `PageNumber=${params.pagination.page}`,
        pageSize: `PageSize=${params.pagination.perPage}`,
        filter: stringify(params.filter),
        sortAttribute: `SortAttribute=${mapSortAttribute(params.sort.field)}`,
        sortDirection: `SortDirection=${mapSortDirection(params.sort.order)}`
    }    
    const queryString = `${queryObject.filter}&${queryObject.pageNumber}&${queryObject.pageSize}&${queryObject.sortAttribute}&${queryObject.sortDirection}`
    const { headers, json } = await httpClient(`${apiUrl}/${resource}?${queryString}`)
    return {
      data: json,
      // @ts-ignore
      total: parseInt((headers.get('content-range') || "0").split('/').pop() || 0, 10)
    }
  }
}

export default dataProvider